export const QA_NAME_ENTITY_TAB_INHABITANTS_ADD_NEW =
  'entityTabInhabitantsAddNew'

export const ENTITY_TAB_INHABITANTS_SUB_TAB_QA_NAME =
  'entityTabInhabitantsSubTab'
